import Boxes from './components/Boxes'

function App() {
  return (
    <div className="App">
      <h1>Create 4 Groups of 4!</h1>
      <Boxes/>
    </div>
  );
}

export default App;
